import { Link } from "react-router-dom";
import { Construction } from "lucide-react";
import NewsletterForm from "../components/NewsletterForm";
import { useT } from "../i18n/I18nProvider";

const SECTION_INFO = {
  demarches: { titleKey: "nav.demarches", desc: "Karta pobytu, PESEL, NIP, compte bancaire, reconnaissance de diplômes... Section en construction." },
  entrepreneuriat: { titleKey: "nav.entrepreneuriat", desc: "JDG, Sp. z o.o., régimes fiscaux, ZUS, convention France-Pologne. Section en construction." },
  education: { titleKey: "nav.education", desc: "Écoles francophones, internationales, crèches. Section en construction." },
  blog: { titleKey: null, title: "Actualités", desc: "Réformes législatives, taux de change, conseils pratiques." },
};

export default function ComingSoon({ sectionKey }) {
  const { t, lp } = useT();
  const info = SECTION_INFO[sectionKey] || { title: sectionKey, desc: "Section en construction." };
  const title = info.titleKey ? t(info.titleKey) : info.title;
  return (
    <div className="max-w-3xl mx-auto px-4 py-20 md:py-28 text-center" data-testid="coming-soon">
      <div className="w-16 h-16 rounded-2xl bg-amber-50 flex items-center justify-center mx-auto mb-6">
        <Construction className="w-7 h-7 text-amber-600" />
      </div>
      <h1 className="font-display text-4xl sm:text-5xl font-bold text-slate-900 tracking-tight">{title}</h1>
      <p className="text-slate-600 mt-4 leading-relaxed">{info.desc}</p>
      <p className="text-slate-500 mt-2 text-sm">{t("comingSoon.notify")}</p>
      <div className="mt-10 max-w-md mx-auto text-left">
        <NewsletterForm source={`coming_soon_${sectionKey}`} />
      </div>
      <Link to={lp("/")} className="mt-10 inline-block hej-link">{t("comingSoon.back")}</Link>
    </div>
  );
}
